import { useMenuData } from 'src/hooks/useMenuData';
import { CafeMenu } from 'src/components/CafeMenu/CafeMenu';
import { ErrorState } from 'src/components/ErrorState/ErrorState';
import { Spinner } from 'src/components/Spinner/Spinner';
import { useCafeSeo } from 'src/hooks/useCafeSeo';

const HomePage = () => {
  const state = useMenuData();

  useCafeSeo(state.status === 'success' ? state.data : undefined);

  if (state.status === 'loading') return <Spinner />;
  if (state.status === 'error') return <ErrorState message={state.message} />;
  
  return (
    <>
      <CafeMenu data={state.data} />
    </>
  );
};

export default HomePage;
